import { DprWeatherDetail } from '@shared/models/dpr';

export interface DprWeatherDetailGridData extends DprWeatherDetail {
  [key: number]: any;
}
